import { merge } from "lodash";
import addressModuleMutations from "./addressModule/mutations";
import shipmentModuleMutations from "./shipmentModule/mutations";
import carrierModuleMutations from "./carrierModule/mutations";

export default merge(addressModuleMutations, shipmentModuleMutations, carrierModuleMutations);
